import React, { useState } from 'react';

const SolutionsCareJourney = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const solutions = [
    {
      id: 1,
      image: '/assets/digitalHealthPlatform/3section-1.svg',
      title: "Women's Health Platform",
      description: "An intelligent, personalized, and connected digital health platform designed to support women from adolescence to menopause—and beyond.​",
      link: '/womens-care'
    },
    {
      id: 2,
      image: '/assets/digitalHealthPlatform/3section-2.svg',
      title: 'Child Health Platform',
      description: "An AI-powered Digital Child Health Platform that supports children's growth, development, and wellbeing through continuous monitoring, and seamless access to pediatric care.",
      link: '/child-care'
    },
    {
      id: 3,
      image: '/assets/digitalHealthPlatform/3section-3.svg',
      title: 'Behavioral Health Platform',
      description: "An AI-powered Digital Child Health Platform that supports children's growth, development, and wellbeing through continuous monitoring, and seamless access to pediatric care.​",
      link: '/behavioral-health'
    },
    {
      id: 4,
      image: '/assets/digitalHealthPlatform/3section-4.svg',
      title: 'Health Concierge Platform​',
      description: "An intelligent, personalized, and connected digital health platform designed to support women from adolescence to menopause—and beyond.​",
      link: '#'
    },
    {
      id: 5,
      image: '/assets/digitalHealthPlatform/3section-5.svg',
      title: 'Second Opinion Platform​',
      description: "A digital second-opinion platform connecting patients to top specialists, advanced diagnostics, and AI-assisted clinical reviews for accurate diagnoses and informed treatment decisions.",
      link: '#'
    },
  ];

  const handlePrevious = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleNext = () => {
    if (currentIndex < solutions.length - 3) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  // Get visible cards (3 at a time, no wrapping)
  const getVisibleCards = () => {
    return solutions.slice(currentIndex, currentIndex + 3);
  };

  const visibleCards = getVisibleCards();

  return (
    <section className="py-8 md:py-12 lg:py-16 light-blue-bg">
      <div className="container mx-auto px-8 md:px-16 lg:px-24 max-w-6xl">
        {/* Header */}
        <div className="text-center mb-10 md:mb-12 lg:mb-14">
          <h2 className="font-bold mb-3 md:mb-4">
            <span className="">Solutions for Every </span>
            <span className="secondary-text">Care Journey</span>
          </h2>
          <p className="   max-w-4xl mx-auto px-4">
            From preventive care to specialized support, Avexa's platform enables tailored digital health solutions across multiple domains.
          </p>
        </div>

        {/* Cards Carousel */}
        <div className="relative">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 mb-8 md:mb-10">
            {visibleCards.map((solution) => (
              <div
                key={solution.id}
                className="group relative bg-white rounded-2xl shadow-lg overflow-hidden transition-shadow duration-300 hover:shadow-xl cursor-pointer"
              >
                {/* Default State - Image and Content */}
                <div className="relative">
                  {/* Image */}
                  <div className="relative h-40 md:h-44 bg-gray-50 overflow-hidden">
                    <img
                      src={solution.image}
                      alt={solution.title}
                      className="w-full h-full object-cover"
                    />
                  </div>

                  {/* Content */}
                  <div className="p-4 md:p-5">
                    <h3 className="   font-bold mb-2 text-center">
                      {solution.title}
                    </h3>
                    <p className="text-gray-600 text-xs md: leading-relaxed text-center">
                      {solution.description}
                    </p>
                  </div>
                </div>

                {/* Hover State - Full Image with Blue Overlay and Button */}
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  {/* Full Card Background Image */}
                  <div className="absolute inset-0">
                    <img
                      src={solution.image}
                      alt={solution.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  
                  {/* Primary Blue Overlay */}
                  <div className="absolute inset-0 primary-bg opacity-90"></div>
                  
                  {/* Centered Button */}
                  <div className="absolute inset-0 flex items-center justify-center z-10">
                    <button
                      onClick={() => window.location.href = solution.link}
                      className="bg-white text-primary-color px-6 py-3 rounded-lg   font-semibold hover:bg-gray-100 transition-colors duration-300"
                    >
                      Explore Platform
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Navigation Buttons */}
          <div className="flex justify-center items-center gap-4">
            <button
              onClick={handlePrevious}
              disabled={currentIndex === 0}
              className={`primary-bg text-white w-12 h-12 md:w-14 md:h-14 rounded-full flex items-center justify-center transition-opacity duration-300 shadow-lg ${
                currentIndex === 0 ? 'opacity-50 cursor-not-allowed' : 'hover:opacity-90'
              }`}
              aria-label="Previous slide"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>

            <button
              onClick={handleNext}
              disabled={currentIndex >= solutions.length - 3}
              className={`primary-bg text-white w-12 h-12 md:w-14 md:h-14 rounded-full flex items-center justify-center transition-opacity duration-300 shadow-lg ${
                currentIndex >= solutions.length - 3 ? 'opacity-50 cursor-not-allowed' : 'hover:opacity-90'
              }`}
              aria-label="Next slide"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SolutionsCareJourney;